<vw-page
  *ngIf="page"
  [page]="page"
  [alwaysFillNav]="true"
  [showDealerInformation]="true"
>
  <div class="thank-you-page">
    <vw-page-header [showEmblemLogotype]="true">
      <div header>
        <div class="row">
          <div class="col-md-7 mx-auto">
            <h1 *ngIf="title" class="text-center">
              {{ title }}
            </h1>
            <div *ngIf="body" [innerHTML]="body | safe: 'html'"></div>
            <p class="text-center" *ngIf="orderId">
              {{
                "thankYouPage.orderId"
                  | translate: { orderId: orderId | number }
              }}
            </p>
            <p class="text-center">
              <i class="fal fa-exclamation-circle attention-circle"></i>
              <span class="fw-bold">
                {{ "thankYouPage.accessoryMontageNotice" | translate }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </vw-page-header>

    <vw-popular-products></vw-popular-products>
  </div>
</vw-page>
